// CHG-0148 (Reid's review 10/30, Connor 11/2): the middle name is a middle initial across the board. A full middle
// name causes problems in Core when statements are sent. Applied to every change a person dialog takes (typed, ID
// scan, Apply corrections); an existing customer's record loaded from Core is left as it is until someone edits it.

/** "Robert" → "R", " r. " → "R"; nothing usable → "". */
export function middleInitial(value?: string | null): string {
  const letter = (value ?? '').match(/\p{L}/u)?.[0];
  return letter ? letter.toUpperCase() : '';
}

/** The patch with its middle name cut to the initial, when the patch carries one. */
export function withMiddleInitial<T extends { middleName?: string | null }>(patch: T): T {
  return patch.middleName == null ? patch : { ...patch, middleName: middleInitial(patch.middleName) };
}
